import { Modal } from '@/components'

import type { FC, Dispatch, SetStateAction } from "react";

interface IModalRule {
  open: boolean,
  onCancel: Dispatch<SetStateAction<boolean>>
}

const ModalRule: FC<IModalRule> = ({ open, onCancel }) => {
  return (
    <Modal
      isOpen={open}
      onCancel={() => onCancel(false)}
    >
      接口还没写完
    </Modal>
  )
}

export default ModalRule
